const mountPopover = (el, options, placement) => {
  placement = placement || 'top';

  const defaultOptions = {
    html: false,
    sanitize: false,
    container: $(el),
    placement: `auto ${placement}`,
    trigger: 'hover focus',
    delay: 400,
  };
  const popoverOptions = typeof options === 'object' ? { ...defaultOptions, ...options } : defaultOptions;

  $(el)
    .popover(popoverOptions)
    .on('show.bs.popover', function () {
      const $el = $(this);

      // adding a custom css class to the tip of the popover specified via data-tipclass
      if ($el.data('tipclass')) {
        $el.data('bs.popover').$tip.addClass($el.data('tipclass'));
      }
    });
};
const destroyPopover = (el) => {
  $(el).popover('hide');
};

export default {
  bind(el, binding) {
    if (binding.value !== false) {
      mountPopover(el, binding.value, binding.arg);
    }
  },
  update(el, binding) {
    if (!!binding.value && binding.oldValue === false) {
      mountPopover(el, binding.value, binding.arg);
    }

    if (!!binding.oldValue && binding.value === false) {
      destroyPopover(el);
    }

    if (binding.value && binding.value.show) {
      $(el).popover('show');
    }
  },
  inserted(el, binding) {
    if (binding.value && binding.value.show) {
      $(el).popover('show');
    }
  },
};
